<template>
    <div class="wrap clearfix">
        <h2>조제/배송 내역<span v-if="!this.is_mobile()" class="h2-notice">(*화면이 깨질 경우, 브라우저 화면을 작게 설정해 주세요. Ctrl+마우스휠다운)</span></h2>
        <div class="btn-group clearfix">
            <!-- <div class="reply-group">
                <input type="checkbox" name="zero-reply" id="zero-reply" v-model="reply_check" @click="set_reply($event.target.checked)">
                <label for="zero-reply"> 미답변 </label> 
                <input type="checkbox" name="is-review" id="is-review" v-model="review_check" @click="set_review($event.target.checked)">
                <label for="is-review"> 리뷰 </label> 
            </div> -->
            <p class="cnt-group">건수 : {{ total_count }}</p> 
        </div>
        <div class="clearfix">
            <div class="left">
                <consult-tel-list :notes="notes" :is_click="is_click" @setClick="setClick" @onSelectRow="onSelectRow" @onConfirm="onConfirm"></consult-tel-list> 
                <div class="left-pager clearfix">
                    <span class="pager-next" @click="page_current>1?load_list(note_type, page_current-1, reply_yn, review_yn):'#'" >&lt;</span>
                    <ul class="pager-list">
                        <li>{{page_current}}</li>
                    </ul>
                    <span class="pager-next" @click="is_paging?load_list(note_type, page_current+1, reply_yn, review_yn):'#'">&gt;</span>
                </div>
            </div>
            <div class="right">
                <ul class="tab">
                    <li :class="{select: tab_no === 1}" @click="select_tab(1,note_id)">상담정보</li>
                    <li :class="{select: tab_no === 2}" @click="select_tab(2,note_id)">수납/진료비청구</li>
                    <li :class="{select: tab_no === 3}" @click="select_tab(3,note_id)">동의서/알림</li>
                    <!-- <li :class="{select: tab_no === 3}" @click="tab_no = 3">리뷰</li> -->
                </ul>
                <div class="box">
                    <consult-tel-content v-show="tab_no === 1" :note_id="note_id" :note_status="note_status" @reload_list="reload_list" ref="consultTelContent" @onConfirm="onConfirm" @onCancel="onCancel"></consult-tel-content> 
                    <consult-tel-payment v-show="tab_no === 2" :note_id="note_id" :note_status="note_status" @reload_list="reload_list" @reload_doc_list="reload_doc_list" :note="chosen_note"></consult-tel-payment>
                    <consult-notice v-show="tab_no === 3" :consult_id="note_id" :note_status="note_status" :consult_type="consult_type" :is_admin="is_admin"></consult-notice>
                </div>
            </div>
            <div id="myModal" class="modal" v-if="is_modal_confirm">
                <!-- Modal content -->
                <div class="modal-content">
                    <div class="modal-header">
                        <span class="close" @click="closeEventConfirm()">&times;</span>
                        <h2>전화상담 접수확인</h2>
                    </div>
                    <div class="modal-body">
                        <ConsultConfirm :account="account" :note="chosen_note" :is_admin="is_admin" ref="ConsultConfirm" @setConfirm="setConfirm"></ConsultConfirm>
                    </div>
                    <div class="modal-footer">

                    </div>
                </div>
            </div>
            <div id="myModal" class="modal" v-if="is_modal_cancel">
                <!-- Modal content -->
                <div class="modal-content">
                    <div class="modal-header">
                        <span class="close" @click="closeEventCancel()">&times;</span>
                        <h2>전화상담 취소</h2>
                    </div>
                    <div class="modal-body">
                        <ConsultCancel :account="account" :note="chosen_note" :status="note_status" :is_admin="is_admin" ref="ConsultCancel" @setCancel="setCancel"></ConsultCancel>
                    </div>
                    <div class="modal-footer">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ConsultTelList from '@/components/ConsultTel/ConsultTelList.vue'
    import ConsultTelContent from '@/components/ConsultTel/ConsultTelContent.vue'
    import ConsultTelPayment from '@/components/ConsultTel/ConsultTelPayment.vue'
    import ConsultNotice from '@/components/Common/ConsultNotice.vue'
    import ConsultConfirm from '@/components/ConsultTel/ConsultConfirm.vue'
    import ConsultCancel from '@/components/ConsultTel/ConsultCancel.vue'
    // import ConsultPush from '@/components/Common/ConsultPush.vue'

    import { nameByConstMixin } from '@/lib/mixins'

//   import { ACCOUNT_TYPE, CONSULT_ACTION, STATUS_CODE, CONSULT_STATUS } from '@/lib/constants'

export default {
    mixins: [ nameByConstMixin ],
    name: 'consult-tel',
    data() {
      return {
        note_id: null,
        notes : [],
        chosen_note: {},
        // note_tab_no: 1,
        note_type : 1,
        page_current : 1,
        page_no : 1,
        is_paging : true,
        total_count: 0,
        reply_yn: 1,
        review_yn: 0,
        reply_check: false,
        review_check: false,
        tab_no: 1,
        note_status: 0,
        is_modal_confirm: false,    //접수확인
        is_modal_cancel: false,    //상담취소
        consult_type: 9,
        is_admin: 0,
        is_click: true
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
        setClick(is_click) {
            this.is_click = is_click;
        },
        select_tab(tab_id, note_id) {
            if(tab_id==2) this.note_id = note_id;
            this.tab_no = tab_id;
        },
        select_type(note_type) {
            if(note_type == undefined)
                note_type = null;
            this.note_type = note_type;

            this.load_list(this.note_type, 1, this.reply_yn, this.review_yn);
        },
        onConfirm() {
            this.is_modal_confirm = true;
        },
        setConfirm(status) {
            // console.log('setConfirm status', status)
            this.reload_list(status); //변경된 값 list 반영
            this.is_modal_confirm = false;
        },
        async closeEventConfirm() {
            this.is_modal_confirm = false;
        },
        onCancel() {
            this.is_modal_cancel = true;
        },
        setCancel(status) {
            // console.log('setCancel status', status)
            this.reload_list(status); //변경된 값 list 반영
            this.is_modal_cancel = false;
        },
        async closeEventCancel() {
            this.is_modal_cancel = false;
        },
        reload_list(consult_status) {
            // console.log("reload_list consult_status", consult_status);
            this.is_click = false;  // 상세화면에서 처리 시 첫번째 상담건 클릭하지 않도록 ... kjw 20200706
            if(consult_status) this.note_status = consult_status;
            this.load_list(this.note_type, this.page_current, this.reply_yn, this.review_yn);
        },
        // just_reload() {
        //     //console.log("reload_list consult_status", consult_status);
        //     this.is_click = false;  // 상세화면에서 처리 시 첫번째 상담건 클릭하지 않도록 ... kjw 20200706
        //     //if(consult_status) this.note_status = consult_status;
        //     this.load_list(this.note_type, this.page_current, this.reply_yn, this.review_yn);
        // },
        reload_doc_list(document_status) {
            // console.log("reload_doc_list document_status", document_status);
            this.is_click = false;  // 상세화면에서 처리 시 첫번째 상담건 클릭하지 않도록 ... kjw 20200706
            if(document_status){
                this.document_status = document_status;
            }
            this.load_list(this.note_type, this.page_current, this.reply_yn, this.review_yn);
        },
        async load_list (note_type = null, page_no = 1, reply_yn = null, review_yn = null ) {

            let params = {
                dr_id : this.account.dr_id,
                page : page_no,
            };

            if(note_type != null){
                params.note_type = note_type;
            }
            if(reply_yn != null){
                params.reply_yn = reply_yn;
            }
            if(review_yn != null){
                params.review_yn = review_yn;
            }          
            
            params.note_type = 9;

            // console.log("/consult_note  params=>" , params);
            let {data} = await this.axios.get(`/consult_note`, {params: params})
            let {resp} = data

            if(data.status == "200"){
                //console.log(data.resp.consults);
                if(resp.consults) {
                    if(resp.total_count) this.total_count = resp.total_count
                    //else this.total_count = 0

                    this.notes = resp.consults

                    // for(var i = 0; i < this.notes.length; i++){
                    //     console.log("note_id = " + this.notes[i].note_id + " : " + this.notes[i].comment);
                    // }
                    this.is_paging = true;
                }
            } else {
                if(page_no > 1) {
                    alert("마지막 페이지입니다.");
                    page_no=page_no-1;
                } else {
                    this.total_count = 0;
                    this.notes = []
                }
                
                this.is_paging = false;
                //return;
            }
            //마지막 페이지처리 20190412 kjw
            this.page_current = page_no
      },
      async onSelectRow (note) {
        //alert('row 선택됨')
        if(note) {
            this.note_status = note.status;
            this.note_id = note.note_id;
            this.chosen_note = note;

            console.log('[ConsultNote]onSelectRow : select note_id = ', note.note_id);
        }
        //this.$refs.consultNoteContent.load_content(note_id);
        // TODO note.note_id로 조회해서 ConsultNoteContent.vue로 전달
      },
      async set_reply (reply_yn) {
        this.review_yn = null;
        this.review_check = false;

        if(reply_yn) this.reply_yn = 0;
        else this.reply_yn = 1;
        
        this.load_list(this.note_type, 1, this.reply_yn, this.review_yn)
      },
      async set_review (review_yn) {
        this.reply_yn = null;
        this.reply_check = false;

        if(review_yn) this.review_yn = 1;
        else this.review_yn = 0;

        this.load_list(this.note_type, 1, this.reply_yn, this.review_yn)
      },
    },
    mounted() {
        this.load_list(this.note_type, this.page_current, this.reply_yn, this.review_yn);
     },
    components: {
      ConsultTelList, ConsultTelContent, ConsultTelPayment, ConsultConfirm, ConsultCancel, ConsultNotice
    }
  }

</script>

<style scoped>
    /* Contents
    ------------------------------------------------------- */
    /* The Modal (background) */
    .modal {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        opacity:0.99;
        z-index: 100; /* Sit on top */
        padding-top: 200px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(9,9,9); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content */
    .modal-content {
        position: relative;
        background-color: #fefefe;
        margin: auto;
        margin-top: 100px;
        padding: 0;
        border: 1px solid #888;
        width: 30%;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
    }

    /* Add Animation */
    @-webkit-keyframes animatetop {
        from {top:-300px; opacity:0} 
        to {top:0; opacity:1}
    }

    @keyframes animatetop {
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    }

    /* The Close Button */
    .close {
        color: white;
        float: right;
        font-size: 40px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .modal-header {
        padding: 5px 20px;
        background-color: #111;
        color: white;
    }

    .modal-body {padding: 0px 0px;}

    .modal-footer {
        padding: 2px 10px;
        background-color: #111;
        color: white;
    }

    /* Main */
    .wrap {
        width: 100%;
        max-width: 1160px;
        margin: 40px auto 40px;
    }

    .wrap h2 {
        margin-bottom: 10px;
        font: 400 24px 'Noto Sans KR', sans-serif;
    }

 /* 버튼그룹(라디오) */
    .btn-group {
        width: 635px;
        margin-bottom: 15px;
    }

    .btn-group .btn-radio {
        float: left;
        font-size: 0;
        margin-top: 5px;
    }

    .btn-group .btn-radio > li {
        color: #aeafb3;
        margin-right: 15px;
        display: inline-block;
    }

    .btn-group .cnt-group {
        color: #999;
        float: right;
        margin-top: 10px;
        margin-right: 5px;
        display: block;
    }

    .btn-group .reply-group {
        color: #999;
        float: left;
        margin-top: 5px;
        /* margin-left: 5px; */
        display: block;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .consult-complete-radio {
        display: block;
        text-indent: 26px;
        cursor: pointer;
        position: relative;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .consult-complete-radio::before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ddd;
        box-sizing: border-box;
        background-color: #fff;
        position: absolute;
        left: 0;
        top: 1px;
    }

    .btn-group .btn-radio input[type="radio"] {
        display: none;
    }

    .btn-group .btn-radio input[type="radio"]:checked + .consult-complete-radio::before {
        border: 3px solid #736ee6;
    }
/* 버튼그룹(라디오) END */

    .btn-date {
        float: right;
        width: 310px;
        height: 32px;
        background-color: #fff;
        position: relative;
    }

    .el-date-editor {
        width: 100%;
    }

    .btn-date > img {
        position: absolute;
        left: 10px;
        top: 6px;
    }

    .btn-date > img, .btn-date > p, .btn-date > ul {
        float: left;
    }

    .btn-date > p {
        margin: 0 10px 0 36px;
        font: 400 14px/30px 'Noto Sans KR', sans-serif;
    }

    .btn-date > ul {
        font-size: 0;
    }

    .btn-date > ul > li {
        display: inline-block;
        font: 400 14px/30px 'Noto Sans KR', sans-serif;
    }

    .left, .right {
        border: 1px solid #e7e7e9;
        box-sizing: border-box;
        background-color: #fff;
    }

    .left {
        width: 630px;
        height: 690px;
        float: left;
        margin-right: 10px;
        position: relative;
    }

    /* left pager */
    .left-pager {
        position: absolute;
        left: 50%;
        bottom: 15px;
        transform: translateX(-50%);
    }

    .left-pager .pager-list,
    .left-pager .pager-next {
        float: left;
    }

    .left-pager .pager-list {
        font-size: 0;
    }

    .left-pager .pager-list > li {
        display: inline-block;
        width: 100%;
        height: 24px;
        cursor: pointer;
        margin-right: 20px;
        text-align: center;
        font: 400 13px/24px 'Noto Sans KR', sans-serif;
    }

    .left-pager .pager-list > li.on {
        border: 1px solid #736ee6;
    }

    .left-pager .pager-next {
        color: #c8c9cb;
        display: inline-block;
        width: 24px;
        height: 24px;
        cursor: pointer;
        text-align: center;
        border: 1px solid #c8c9cb;
        font: 400 14px/24px 'Roboto', sans-serif;
    }

    .left-pager .pager-btn {
        width: 5rem;
        height: 2rem;
        letter-spacing: 0.5px;
    }   

    .right {
        width: 514px;
        float: left;
    }

    .right .tab {
        width: 100%;
        height: 50px;
        font-size: 0;
        box-sizing: border-box;
        border-bottom: 1px solid #e7e7e9;
    }

    .right .tab > li {
        color: #b8b8b8;
        width: 33.3333%;
        /* width: 50%; */
        height: 50px;
        cursor: pointer;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font: 500 15px/50px 'Noto Sans KR', sans-serif;
    }

    .right .tab > li:hover,
    .right .tab .select {
        color: #736ee6;
        position: relative;
    }

    .right .tab > li:hover::after,
    .right .tab .select::after {
        content: '';
        display: block;
        width: 100%;
        height: 3px;
        position: absolute;
        bottom: 0;
        background-color: #736ee6;
    }

    .right .box {
        width: 100%;
        height: 640px;
        padding: 30px 30px 0;
        overflow-y: scroll;
        position: relative;
        box-sizing: border-box;
    }

    .h2-notice {
        color: #999;
        margin: 0 0 0 10px;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }
    
</style>
